import React from 'react';
import { useTranslation } from 'react-i18next';

import { TFunction } from 'i18next';
import { OPERATOR_CONDITIONS, RULE_ACTION_TYPE } from 'Common/enums';
import { getFullStringCondition } from 'Utils';
import { CONCLUSION_STATEMENT } from '../constants';
import styles from './styles.css';

const getConditionString = (
    conditions: TransformedConditionObj[],
    listMap: ListManagementApiListIdHashMap,
    parameterMap: ParameterFieldIdHashmap,
    t: TFunction
) => {
    let statementArrayNew: string[] = [];

    let index = 1;
    conditions.forEach((condition: TransformedConditionObj) => {
        let newArray: string[] = [];
        if (
            condition.operator === OPERATOR_CONDITIONS.STR_NOT_IN_LIST ||
            condition.operator === OPERATOR_CONDITIONS.STR_IN_LIST
        ) {
            newArray = condition.values.map((value: number) => [listMap[value]?.name || '']);
        }
        statementArrayNew = [
            ...statementArrayNew,
            condition.operator
                ? [
                      index > 1 ? t('and') : '',
                      parameterMap[condition.fieldName]?.message ||
                          parameterMap[condition.fieldName.toUpperCase()]?.message,
                      getFullStringCondition(t, condition.operator),
                      newArray.length ? `[${newArray}]` : `[${condition.values}]`
                  ].join(' ')
                : ''
        ];
        index++;
    });

    return statementArrayNew.join(' ');
};

const getActionString = (
    action: Action[],
    listMap: ListManagementApiListIdHashMap,
    parameterMap: ParameterFieldIdHashmap,
    conclusionFlagListData: ConclusionListApiGetResponse[],
    t: TFunction
) => {
    let statementArrayNew: string[] = [];
    let statement = '';
    let index = 1;
    action.forEach((item: Action) => {
        let newArray: string[] = [];
        if (item.operator === '') statement = '';
        else if (
            item.operator === RULE_ACTION_TYPE.ACCEPT ||
            item.operator === RULE_ACTION_TYPE.REJECT ||
            item.operator === RULE_ACTION_TYPE.REVIEW
        )
            statement = CONCLUSION_STATEMENT[item.operator];
        else if (item.operator === RULE_ACTION_TYPE.UPDATE_SCORE_BY) {
            statement = CONCLUSION_STATEMENT[item.operator].concat(` [${item.values}]`);
        } else if (item.operator === RULE_ACTION_TYPE.SET_FLAGS) {
            newArray = (item.values as Array<string>).map((value: string) => {
                const conclusion = conclusionFlagListData?.filter((obj: { name: string }) => obj.name === value) || [];
                return [...newArray, conclusion[0]?.description];
            })[0];
            statement = CONCLUSION_STATEMENT[item.operator].concat(` [${newArray}]`);
        } else if (item.operator === RULE_ACTION_TYPE.ADD_TO_LIST) {
            const { fieldName, listIds } = item.values as AddToList;
            if (listIds) {
                const listNames = listIds.map((value) => listMap[Number(value)]?.name || '');
                newArray = [...newArray, ...listNames];
            }
            const { operator } = item;
            const operatorString = [
                CONCLUSION_STATEMENT[operator].substring(0, CONCLUSION_STATEMENT[operator].indexOf('[') + 1) +
                    (parameterMap[fieldName]?.message || '') +
                    CONCLUSION_STATEMENT[operator].substring(
                        CONCLUSION_STATEMENT[operator].indexOf(']'),
                        CONCLUSION_STATEMENT[operator].length
                    )
            ];
            statement = operatorString[0].concat(` [${newArray}]`);
        }
        statementArrayNew = [...statementArrayNew, [index > 1 ? t('and') : '', statement].join(' ')];
        index++;
    });
    return statementArrayNew.join(' ');
};

const RuleStatement = ({
    parameterData,
    listData,
    conclusionFlagListData,
    conditions,
    actions
}: {
    parameterData?: UseGetParametersResponse;
    listData?: ListApiGetResponse;
    conclusionFlagListData?: ConclusionListApiGetResponse[];
    conditions: TransformedConditionObj[];
    actions: Actions;
}) => {
    const { t } = useTranslation();

    const condition = getConditionString(
        conditions,
        listData?.listIdHashMap || [],
        parameterData?.fieldNameHashmap as ParameterFieldIdHashmap,
        t
    );

    const action = getActionString(
        actions,
        listData?.listIdHashMap || [],
        parameterData?.fieldNameHashmap as ParameterFieldIdHashmap,
        conclusionFlagListData || [],
        t
    );

    return (
        <div className={styles.container}>
            {conditions[0].operator && (
                <div className={styles.condition}>
                    <div className={styles.label}>{t('WHEN')}</div>
                    <div className={styles.statement}>{condition}</div>
                </div>
            )}

            {actions[0].operator !== '' && (
                <div className={styles.action}>
                    <div className={styles.label}>{t('THEN')}</div>
                    <div className={styles.statement}>{action}</div>
                </div>
            )}
        </div>
    );
};

export default RuleStatement;
